// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1ok5F","notes":"Notes_notes__2hsCi","note":"Notes_note__2C-dQ","markdown":"Notes_markdown__1pDWx"};